/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable max-len */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button, FlexContainer } from '../../../../globalStyles';
import { Creators as UpsertWorkOrderCreators } from '../store';
import TabsTable from '../../../Common/Tabs_Table';
import Header from '../Header';
import { Bttn } from './AssetSelection.style';
import { WorkOrderCreators } from '../../../../views/WorkOrders/store';
import { getStringLocale } from '../../../../constants/language';
import {
  DetailLabel,
  DetailText,
  EnlargedImage,
  HeaderText,
  PartDetailsContainer,
  PartHeader,
  PartImage,
  PartName,
  PartsContainer
} from '../../WorkOrderDetails/WorkOrderDetails.style';
import PopUpModal from '../../../Common/PopUpModal/Modal.view';
import { CancelBlack } from '../../../../assets/icons';
import DynamicSVGIcon from '../../../Common/DynamicSVGIcon';

export default function AssetShortlist() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    type,
    assetShortlist,
    assetListMeta,
    workOrderCreationFrom
    // , assetSearchQueries
  } = useSelector((state) => state.upsertWorkOrder);
  const { assetType } = useSelector((state) => state.filterData);
  const planDetails = useSelector((state) => state.plansData.planDetails);
  // duplicate
  const handleShortList = (entry) => {
    const check = assetShortlist.some(
      (ele) =>
        ele.mainPartNumber === entry.mainPartNumber &&
        ele.inventPartnumber === entry.inventPartnumber
    );
    if (!check) {
      dispatch(
        UpsertWorkOrderCreators.setAssetShortlist([...assetShortlist, entry])
      );
    } else {
      dispatch(
        UpsertWorkOrderCreators.setAssetShortlist(
          assetShortlist.filter(
            (ele) =>
              !(
                ele.mainPartNumber === entry.mainPartNumber &&
                ele.inventPartnumber === entry.inventPartnumber
              )
          )
        )
      );
    }
  };
  const handleNext = () => {
    dispatch(
      WorkOrderCreators.getUserDataByTemplateId({
        WFTid: type.workflowTemplateId,
        assetType,
        workOrderCreationFrom,
        scheduleId: planDetails.scheduleId,
        selections: assetShortlist
      })
    );
    navigate('/home/work_orders/create_WO/form');
  };

  // const setAssetSearchQueries = (searchQueries) => {
  //   dispatch(UpsertWorkOrderCreators.setAssetSearchQueries(searchQueries));
  // };
  // console.log('assetSearchQueries', assetSearchQueries);

  const [enlargeImage, setEnlargeImage] = useState({});

  return (
    <div style={{ height: '100%' }}>
      <div
        style={{
          height: '85vh',
          width: '99vw',
          overflow: 'auto',
          padding: '1rem'
        }}
      >
        {assetShortlist?.map((asset) => {
          const assetInList = assetShortlist.some(
            (ele) =>
              ele.mainPartNumber === asset.mainPartNumber &&
              ele.inventPartnumber === asset.inventPartnumber &&
              ele.qtyAvailable === asset.qtyAvailable
          );
          return (
            <>
              <PartsContainer>
                <PartHeader>
                  <PartImage
                    src={asset?.unfurlImageUrl}
                    width='120px'
                    height='150px'
                    onClick={() => {
                      setEnlargeImage({ display: true, asset });
                    }}
                  />
                  <PartName>{asset?.partName}</PartName>
                </PartHeader>
                <PartDetailsContainer>
                  <FlexContainer className='ai_center'>
                    <DetailLabel>
                      {getStringLocale('Main Part', 'en')}
                    </DetailLabel>
                    <DetailText>{`: ${
                      asset?.mainPartNumber || '-'
                    }`}</DetailText>
                  </FlexContainer>
                  <FlexContainer className='ai_center'>
                    <DetailLabel>
                      {getStringLocale('Invent Part', 'en')}
                    </DetailLabel>
                    <DetailText>{`: ${
                      asset?.inventPartNumber || '-'
                    }`}</DetailText>
                  </FlexContainer>
                  <FlexContainer className='ai_center'>
                    <DetailLabel>
                      {getStringLocale('Location', 'en')}
                    </DetailLabel>
                    <DetailText>{`: ${asset?.location || '-'}`}</DetailText>
                  </FlexContainer>
                  <FlexContainer className='ai_center'>
                    <DetailLabel>
                      {getStringLocale('Equipment Type', 'en')}
                    </DetailLabel>
                    <DetailText>{`: ${
                      asset?.equipmenttype || '-'
                    }`}</DetailText>
                  </FlexContainer>

                  <FlexContainer className='ai_center'>
                    <DetailLabel>{getStringLocale('In La', 'en')}b</DetailLabel>
                    <DetailText>{`: ${asset?.inLab || '-'}`}</DetailText>
                  </FlexContainer>
                  <FlexContainer className='ai_center'>
                    <DetailLabel>
                      {getStringLocale('Qty Available', 'en')}
                    </DetailLabel>
                    <DetailText>{`: ${asset?.qtyAvailable || '-'}`}</DetailText>
                  </FlexContainer>
                  <FlexContainer className='ai_center'>
                    <DetailLabel>{getStringLocale('Price', 'en')}</DetailLabel>
                    <DetailText>{`: ${asset?.BlendedCost || '-'}`}</DetailText>
                  </FlexContainer>
                  <FlexContainer className='ai_center'>
                    <DetailLabel>
                      O{getStringLocale('Old P/N', 'en')}
                    </DetailLabel>
                    <DetailText>{`: ${asset?.old || '-'}`}</DetailText>
                  </FlexContainer>
                </PartDetailsContainer>
                <Button
                  style={{
                    padding: '1rem',
                    borderRadius: '10px',
                    width: '100%',
                    margin: '2rem 0 0 0'
                  }}
                  onClick={() => {
                    handleShortList(asset);
                  }}
                  className={assetInList && 'remove'}
                  dark={true}
                >
                  {assetInList ? 'Remove' : 'Add'}
                </Button>
              </PartsContainer>
            </>
          );
        })}
      </div>
      <FlexContainer className='ai_center jc_center'>
        <Bttn
          className='dark'
          onClick={() => {
            navigate(-1);
          }}
        >
          {getStringLocale('Cancel')}
        </Bttn>
        <Bttn className='white' onClick={handleNext}>
          {getStringLocale('Next')}
        </Bttn>
      </FlexContainer>
      {enlargeImage?.display && (
        <PopUpModal
          closeModalHandler={() => {
            setEnlargeImage({});
          }}
          style={{ height: '60%' }}
        >
          <FlexContainer
            className='ai_center jc_spacebetween'
            style={{ marginBottom: '2rem' }}
          >
            <HeaderText>
              {getStringLocale(
                `${enlargeImage?.asset?.inventPartNumber}`,
                'en'
              )}
            </HeaderText>
            <div
              style={{ textAlign: 'end' }}
              onClick={() => {
                setEnlargeImage({});
              }}
            >
              <DynamicSVGIcon iconUrl={CancelBlack} width='1.5rem' />
            </div>
          </FlexContainer>

          <div style={{ height: '90%' }}>
            <EnlargedImage
              src={enlargeImage?.asset?.unfurlImageUrl}
              alt='part'
            />
          </div>
        </PopUpModal>
      )}
    </div>
  );
}
